import type { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  caption?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ eyebrow, title, caption, actions, className }: PageHeaderProps) {
  return (
    <header
      className={cn(
        "flex items-start justify-between gap-3 md:items-end md:gap-4",
        className,
      )}
    >
      <div className="min-w-0 space-y-0.5">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="display-title">{title}</h1>
        {caption && <p className="text-text-faint text-[13px]">{caption}</p>}
      </div>
      {actions && (
        <div className="flex flex-col items-stretch gap-2 md:flex-row md:items-center">
          {actions}
        </div>
      )}
    </header>
  );
}
